import styled from "styled-components";


export const BaseText = styled.div`
  font-size: ${props => props.fontSize};
  color: ${props => props.color };
  font-family: Heebo,sans-serif;
  font-weight: ${props => props.fontWeight};
  line-height: ${props => props.lineHeight};
`;